<template>
  <iframe v-if="URL" :src="URL" frameborder="0" allowfullscreen='true'></iframe>
</template>

<script>
export default {
  name: 'resource',
  components: {},
  props: [],
  data() {
    return {
      URL: undefined
    }
  },
  watch: {},
  computed: {},
  created() {
    document.title = window.localStorage.getItem('title')
    this.URL = window.localStorage.getItem('url')
  },
  mounted() {
    window.localStorage.clear()
    if (!this.URL) {
      this.$router.push('/experiments')
    }
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
iframe {
  width: 100vw;
  height: 100vh;
}
</style>